import React from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '../../store'
import RemoteContainer from './Remote/RemoteContainer'
import MobileContainer from './Mobile/MobileContainer'
import { LanguageButton } from './Common'

interface MenuDisplayerProps {
  hideMenu?: boolean
}

const MenuDisplayer = ({ hideMenu }: MenuDisplayerProps): JSX.Element => {
  const isMobile = useSelector((state: RootState) => state.viewReducer.isMobile)
  const displayControls = useSelector((state: RootState) => state.viewReducer.displayControls)
  const configuration = useSelector((state: RootState) => state.retorikReducer.configuration)

  return !displayControls ? (
    <React.Fragment />
  ) : isMobile ? (
    <MobileContainer hideMenu={!!hideMenu} />
  ) : (
    <React.Fragment>
      <RemoteContainer hideMenu={!!hideMenu} />
      {!configuration.languageChoiceBottom?.setUnderRemote && <LanguageButton />}
    </React.Fragment>
  )
}

export default MenuDisplayer
